<script lang="ts">
    import {Kind} from 'shared/constants';
    import type {Message, MessageSending} from 'src/typings';
    import {getDateFormatter, getInjector} from 'src/core';
    import {KpMessageService} from '../../../messages/services/kp-message.service';
    import {fade, slide} from 'svelte/transition';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import Label from 'shared/components/kp-label/Label.svelte';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';
    import KpLoadingInline from 'shared/components/kp-loading/KpLoadingInline.svelte';
    import KpMessageSending from '../../../messages/KpMessageSending.svelte';

    export let message: Message;

    const dateFormatter = getDateFormatter();
    const service = getInjector().getByClass(KpMessageService);
    const messageSendingsSlideAnimParams = {duration: 250};

    let sendings: MessageSending[];
    let loadingSendings = false;
    let sendingsShown = false;

    const handleToggleSendingsOpenClick = async () => {
        if (exists(sendings)) {
            sendingsShown = !sendingsShown;
            return;
        }

        loadingSendings = true;
        sendings = await service.loadMessageSendings(message.id);
        loadingSendings = false;

        sendingsShown = !sendingsShown;
    }
</script>

<tr id="search-item-message-{message.id}"
    class="kp-search-item-message-row"
    in:fade>

    <td class="data-target">
        <Label explicitKind={Kind.KIND_USER} labeled={message.targetUser}/>
    </td>

    <td class="data-created">
        {pipe(message.creationDate, dateFormatter('d.M.yyyy'))}
    </td>

    <td class="data-topic">
        {pipe(message.topic, loc())}
    </td>

    <td class="data-severity">
        <div class="severity-info-badge {message.severity.id.toString()}">
            {pipe(message.severity, loc())}
        </div>
    </td>

    <td class="data-more">
        {#if !loadingSendings}
            <KpButton on:click={handleToggleSendingsOpenClick}>
                <IconedContent icon={sendingsShown ? 'zoom-out' : 'zoom-in'}/>
            </KpButton>
        {:else}
            <div class="loading-container">
                <KpLoadingInline size="xs"/>
            </div>
        {/if}
    </td>
</tr>

{#if !loadingSendings && sendingsShown && exists(sendings)}
    <tr class="message-sendings-row"
        aria-label="Odeslání zprávy"
        aria-labelledby="search-item-message-{message.id}">

        <td class="full-span-data" colspan="5">
            <ul class="message-sendings-list" transition:slide={messageSendingsSlideAnimParams}>
                <li class="message-sending-list-item">
                    {#each sendings as sending(sending.id)}
                        <KpMessageSending {sending}/>
                    {/each}
                </li>
            </ul>
        </td>
    </tr>
{/if}

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .kp-search-item-message-row {
        .severity-info-badge {
            display: inline-block;
            border-radius: @border-radius-base;
            padding: @padding-base-vertical @padding-base-horizontal;

            .severity-background(@severity, @bg-color) {
                &.@{severity} {
                    background-color: @bg-color;
                }
            }

            .severity-background(info, @alert-info-bg);
            .severity-background(warning, @alert-warning-bg);
            .severity-background(urgent, @alert-danger-bg);
        }

        .data-more {
            position: relative;

            .loading-container {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

    .message-sendings-row {
        padding: 0;

        td {
            padding: 0 !important;
        }

        .message-sendings-list {
            display: flex;
            flex-direction: column;
            padding: @panel-body-padding;

            .message-sending-list-item {
                display: inline-block;
                border-bottom: @table-border-color;
                margin-left: @panel-body-padding;

                &:last-child {
                    border-bottom: none;
                }
            }
        }
    }
</style>